export interface CostCenterLabelParts {
  id?: string | null;
  codigo?: string | null;
  code?: string | null;
  descricao?: string | null;
  description?: string | null;
  nome?: string | null;
  name?: string | null;
}

const firstFilled = (...values: Array<string | null | undefined>): string => (
  values.find((value) => !!value?.trim())?.trim() ?? ''
);

export const formatCostCenterLabel = (costCenter: CostCenterLabelParts): string => {
  const code = firstFilled(costCenter.codigo, costCenter.code);
  const description = firstFilled(
    costCenter.descricao,
    costCenter.description,
    costCenter.nome,
    costCenter.name
  );

  if (code && description) return `${code} - ${description}`;
  return description || code;
};

export const getCostCenterSnapshot = (costCenter: CostCenterLabelParts): {
  costCenterCode?: string;
  costCenterName?: string;
} => {
  const costCenterCode = firstFilled(costCenter.codigo, costCenter.code) || undefined;
  const costCenterName = firstFilled(
    costCenter.descricao,
    costCenter.description,
    costCenter.nome,
    costCenter.name
  ) || undefined;

  return { costCenterCode, costCenterName };
};
